export default __webpack_public_path__ + "static/media/ATO-2.a83602ef.png";